var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ou)?_c('div',{staticClass:"odd-labels"},_vm._l((_vm.ou.odd),function(odd){return _c('div',{},[_c('Selection',{attrs:{"selectedOdds":_vm.selectedOdds,"odd":odd,"match":_vm.match,"market":_vm.ou}})],1)}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9d1a1ee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sportsbook/winOdds.vue
// module id = lTav
// module chunks = 0